import type { FC } from 'react';

import type { LicenseConfig } from 'config/types';

import AnjouanLicense from './AnjouanLicense';
import GCLicense from './GCLicense';

const License: FC<LicenseConfig> = (props) => {
  switch (props.name) {
    case 'anjouan':
      return <AnjouanLicense id={props.licenseId} domId={props.domId} />;
    case 'gc':
      return <GCLicense id={props.licenseId} />;
    default:
      return null;
  }
};

export default License;
